/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import PriceFormat from "components/PriceFormat";
import { Button, FormGroup, Label, Input } from "reactstrap";

const OrderSummary = ({
  orderSuccess,
  items,
  promotionalDiscount,
  totalDiscount,
  subtotal,
  salesTax,
  billingStateCode,
  total,
  stepsReviewVisible,
  validAccept,
  loading,
  handleOrderSummaryValid,
  handleStepOrder,
  orderItems,
  orderTotalDiscount,
  orderSubtotal,
  orderPromotionalDiscount,
  orderSalesTax,
  orderTotal
}) => {
  return (
    <div className="checkout__summary">
      <h2>Order Summary</h2>

      {!orderSuccess && (
        <table className="table checkout__summary-table">
          <tbody>
            {items.map(item => (
              <tr key={item.sku}>
                <td>{item.productName}</td>
                <td>
                  <PriceFormat value={item.retailPrice} />
                </td>
              </tr>
            ))}
            <tr className="has-divider">
              <td>Discounts</td>
              {totalDiscount && totalDiscount > 0 ? (
                <td>
                  -&nbsp;
                  <PriceFormat value={totalDiscount} />
                </td>
              ) : (
                <td>&mdash;</td>
              )}
            </tr>
            <tr>
              <td>Subtotal</td>
              <td>
                <PriceFormat value={subtotal} />
              </td>
            </tr>
            {promotionalDiscount > 0 && (
              <tr>
                <td>Promotional Discounts</td>
                <td>
                  -&nbsp;
                  <PriceFormat value={promotionalDiscount} />
                </td>
              </tr>
            )}
            <tr className="has-divider">
              <td>
                Taxes
                {salesTax >= 0 && (
                  <span className="checkout__summary-taxes">
                    Taxes for&nbsp;
                    {billingStateCode}
                  </span>
                )}
              </td>
              <td>
                {salesTax >= 0 ? (
                  <PriceFormat value={salesTax} />
                ) : (
                  <span>&mdash;</span>
                )}
              </td>
            </tr>
            <tr>
              <td>Total</td>
              <td>
                <PriceFormat value={total} />
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {!orderSuccess && stepsReviewVisible && (
        <div>
          <FormGroup className="form-check">
            <Input
              id="orderSummary_handleOrderSummaryValid"
              htmlFor="privacy policy agreement"
              type="checkbox"
              value={validAccept}
              onClick={() => handleOrderSummaryValid()}
            />
            <Label className="checkout__summary-legal">
              By placing this order, I agree to HealthStream’s&nbsp;
              <a
                href="https://www.healthstream.com/privacy-statement"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              &nbsp;and&nbsp;
              <a
                href="https://www.healthstream.com/operational-pages/terms-of-use"
                rel="noopener noreferrer"
                target="_blank"
              >
                Terms of Use
              </a>
              .
            </Label>
          </FormGroup>
          <div className="checkout__step-continue">
            <Button
              id="orderSummary_handleStepOrder"
              block
              color="primary"
              onClick={handleStepOrder}
              disabled={!validAccept || loading}
            >
              Place Order
            </Button>
          </div>
        </div>
      )}

      {!orderSuccess && loading && (
        <div className="checkout__summary-blocker" />
      )}

      {orderSuccess && (
        <table className="table checkout__summary-table">
          <tbody>
            {orderItems.map(item => (
              <tr key={item.sku}>
                <td>{item.productName}</td>
                <td>
                  <PriceFormat value={item.retailPrice} />
                </td>
              </tr>
            ))}
            <tr className="has-divider">
              <td>Discounts</td>
              {orderTotalDiscount && orderTotalDiscount > 0 ? (
                <td>
                  -&nbsp;
                  <PriceFormat value={orderTotalDiscount} />
                </td>
              ) : (
                <td>&mdash;</td>
              )}
            </tr>
            <tr>
              <td>Subtotal</td>
              <td>
                <PriceFormat value={orderSubtotal} />
              </td>
            </tr>
            {orderPromotionalDiscount > 0 && (
              <tr>
                <td>Promotional Discounts</td>
                <td>
                  -&nbsp;
                  <PriceFormat value={orderPromotionalDiscount} />
                </td>
              </tr>
            )}
            <tr className="has-divider">
              <td>
                Taxes
                {orderSalesTax >= 0 && (
                  <span className="checkout__summary-taxes">
                    Taxes for&nbsp;
                    {billingStateCode}
                  </span>
                )}
              </td>
              <td>
                {orderSalesTax ? (
                  <PriceFormat value={orderSalesTax} />
                ) : (
                  <span>&mdash;</span>
                )}
              </td>
            </tr>
            <tr>
              <td>Total</td>
              <td>
                <PriceFormat value={orderTotal} />
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

OrderSummary.propTypes = {
  orderSuccess: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  totalDiscount: PropTypes.number,
  promotionalDiscount: PropTypes.number,
  subtotal: PropTypes.number.isRequired,
  salesTax: PropTypes.number,
  billingStateCode: PropTypes.string,
  total: PropTypes.number.isRequired,
  stepsReviewVisible: PropTypes.bool.isRequired,
  validAccept: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  handleOrderSummaryValid: PropTypes.func.isRequired,
  handleStepOrder: PropTypes.func.isRequired,
  orderItems: PropTypes.array.isRequired,
  orderTotalDiscount: PropTypes.number,
  orderSubtotal: PropTypes.number.isRequired,
  orderSalesTax: PropTypes.number,
  orderPromotionalDiscount: PropTypes.number,
  orderTotal: PropTypes.number.isRequired
};

OrderSummary.defaultProps = {
  salesTax: null,
  totalDiscount: null,
  promotionalDiscount: null,
  orderTotalDiscount: null,
  orderPromotionalDiscount: null,
  orderSalesTax: null,
  billingStateCode: null
};

export default OrderSummary;
